import { render, staticRenderFns } from "./Dollars.vue?vue&type=template&id=3d410574"
import script from "./Dollars.vue?vue&type=script&lang=js"
export * from "./Dollars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports